export const NAVBAR_ICON_BUTTON_BASE =
  "border p-2 rounded-full flex items-center justify-center w-10 h-10 min-w-[44px] min-h-[44px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

export const NAVBAR_ICON_BUTTON_BORDER =
  "border-gray-300 dark:border-gray-500";

/** Matches three-dots / navbar icon foreground. */
export const NAVBAR_ICON_BUTTON_ICON_CLASS =
  "text-gray-900 dark:text-gray-100";

/** Neutral circular icon button (settings, three-dots, etc.). */
export const NAVBAR_ICON_BUTTON_CLASS = `${NAVBAR_ICON_BUTTON_BASE} bg-gray-200 dark:bg-gray-600 ${NAVBAR_ICON_BUTTON_BORDER} hover:bg-gray-300 dark:hover:bg-gray-500`;

/** Companion settings — border/icon match three-dots; light bg reflects connection. */
export function getCompanionSettingsButtonClass(connected) {
  if (connected) {
    return `${NAVBAR_ICON_BUTTON_BASE} ${NAVBAR_ICON_BUTTON_BORDER} bg-green-100 hover:bg-green-200 dark:bg-green-900/40 dark:hover:bg-green-900/55`;
  }
  return `${NAVBAR_ICON_BUTTON_BASE} ${NAVBAR_ICON_BUTTON_BORDER} bg-amber-100 hover:bg-amber-200 dark:bg-amber-900/40 dark:hover:bg-amber-900/55`;
}
